import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu } from '@sequencehq/core-components'
import { QuoteTemplatePickerModal } from 'common/modals/quotes/quoteTemplatePicker.modal'
import { usePermissions } from 'lib/rbac'
import { useState } from 'react'

type QuoteTemplate = DashboardApi20240730.GetQuoteTemplate.Response

export const SelectQuoteTemplateMenuItem = (props: {
  onSelect: (template: QuoteTemplate) => void
  hasSalesforceOpportunityId?: boolean
  disabled?: boolean
  disabledReason?: string
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const { can } = usePermissions()

  if (!can('org.quote:update')) {
    return null
  }

  return (
    <>
      <SequenceMenu.Item
        uuid="select-quote-template"
        label="Apply quote template"
        data-testid={`quotes.selectQuoteTemplate.menuItem`}
        isDisabled={props.disabled}
        tooltip={props.disabledReason}
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <QuoteTemplatePickerModal
          onClose={() => setShowModal(false)}
          onSelect={props.onSelect}
          hasSalesforceOpportunityId={props.hasSalesforceOpportunityId}
        />
      )}
    </>
  )
}
